<template>
    <div>
        <component
            v-if="params.component"
            v-bind="params.props"
            :is="params.component"
            ref="modal">
        </component>
        <div ref="container"></div>
    </div>
</template>
<script>

import Vue from 'vue'
import Plugin from './index'

export default {
    name: 'ContainerDialog',
    data() {
        return {
            modal: null,
            params: {
                component: undefined,
                props: {}
            },
        }
    },
    methods: {
        showComponent(modal, modalProps) {
            let me = this;
            me.params = {
                component: modal,
                props: modalProps,
            }
            return new Promise((resolve, reject) => {
                me.$nextTick(() => {
                    me.$refs.modal.show()
                        .then(event => {
                            if (event && event.trigger) Plugin.event.$emit(event.trigger, event)
                            resolve(event)
                        }).catch(err => reject(err))
                })
            })
        },
        show(modal, modalProps) {
            //TODO show modal component by string name
            const instance = new Vue({
                ...modal,
                parent: this,
                propsData: modalProps,
                inheritAttrs: true,
            })
            instance.$mount() // pass nothing
            this.$refs.container.appendChild(instance.$el)
            return instance.show()
        }
    },

    beforeMount() {
        Plugin.rootInstance = this;
    }
}
</script>
<style>

</style>
